!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (n, r) {
  return a = {}, o.m = i = {
    0: function (e, t) {
      e.exports = n;
    },
    1: function (e, t) {
      e.exports = r;
    },
    741: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return o;
      });
      var t = n(0),
        r = n.n(t),
        t = n(1),
        n = n.n(t),
        t = function () {
          return r.a.createElement("g", {
            fill: "none"
          }, r.a.createElement("defs", null, r.a.createElement("path", {
            id: "RIkKfwiRw7",
            d: "M0 .226h19.976v19.947H0z"
          })), r.a.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, r.a.createElement("g", {
            transform: "translate(.518 .259)"
          }, r.a.createElement("mask", {
            id: "Q71ngR9z6X",
            fill: "#fff"
          }, r.a.createElement("use", {
            xlinkHref: "#RIkKfwiRw7"
          })), r.a.createElement("path", {
            fill: "#CF232A",
            d: "M9.986 17.616c3.738 0 5.41-2.974 5.41-5.921 0-4.15-2.882-8.882-5.41-8.882-2.519 0-5.403 4.731-5.403 8.882 0 2.947 1.672 5.921 5.403 5.921m9.99.588a2 2 0 0 1-1.998 1.997H1.998A2 2 0 0 1 0 18.203V2.223A2 2 0 0 1 1.998.225l15.98.001c1.102 0 1.998.893 1.998 1.995v15.982",
            mask: "url(#Q71ngR9z6X)"
          })), r.a.createElement("path", {
            fill: "#FFFFFE",
            d: "M15.91 11.94c0-4.15-2.882-8.88-5.406-8.88-2.523 0-5.403 4.73-5.403 8.88 0 2.947 1.667 5.922 5.403 5.922 3.738 0 5.406-2.975 5.406-5.922"
          })));
        };
      t.svg = {
        viewBox: "0 0 21 21"
      };
      var o = n()(t);
    }
  }, o.c = a, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 741);
  function o(e) {
    if (a[e]) return a[e].exports;
    var t = a[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, a;
});